"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conversational = void 0;
var PerceivedImpulse_1 = require("./PerceivedImpulse");
/**
 * Type which contains all impulses needed for the maintainence of a conversation
 */
var Conversational = /** @class */ (function (_super) {
    __extends(Conversational, _super);
    function Conversational() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Conversational";
        /**
         * Utterance perception impulse used to send an utterance text to gaia
         */
        _this.perceiveUtterance = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveUtterance(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * Button perception impulse used to send a button action to gaia
         */
        _this.perceiveButton = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveButton(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * Submit perception impulse used to send a submit action to gaia
         */
        _this.perceiveSubmit = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveSubmit(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * Reception perception impulse used to send a reception to gaia
         */
        _this.perceiveReception = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveReception(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * Suggestion perception impulse used to send a suggestion action to gaia
         */
        _this.perceiveSuggestion = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveSuggestion(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Conversational;
}(Array));
exports.Conversational = Conversational;
//# sourceMappingURL=Conversational.js.map